export default {"src":"/_next/static/media/facultyExist.4a59ead4.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};